import { Link } from "react-router-dom";

interface IconProps {
  size?: number;
  color?: string;
}

export type LogoType = "grand" | "small";

export type LogoProps = IconProps & {
  type?: LogoType;
  onClick?: () => void;
  to?: string;
};

export default function Logo({
  size = 100,
  color = "black",
  type,
  onClick: handleClick,
  to,
}: LogoProps) {
  const Logo = () => {
    switch (type) {
      case "grand":
        return <LogoGrand size={size} color={color} />;
      case "small":
        return <LogoIcon size={size} color={color} />;
      default:
        return <LogoGrand size={size} color={color} />;
    }
  };

  const style = handleClick ? { cursor: "pointer" } : {};

  if (to) {
    return <Link to={to}>{Logo()}</Link>;
  }

  return (
    <div onClick={handleClick} style={style}>
      {Logo()}
    </div>
  );
}

function LogoGrand({ size = 100, color = "black" }: IconProps) {
  return (
    <svg
      width={size}
      viewBox="0 0 106 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0072 15.0555C30.5738 15.0555 30.1732 14.9519 29.8055 14.7447C29.4509 14.5375 29.1685 14.259 28.9584 13.9093C28.7483 13.5467 28.6432 13.1517 28.6432 12.7243V11.617H30.2389V12.7243C30.2389 12.9315 30.3111 13.1128 30.4556 13.2683C30.6132 13.4107 30.797 13.4819 31.0072 13.4819H40.463C40.6731 13.4819 40.8504 13.4107 40.9949 13.2683C41.1525 13.1128 41.2313 12.9315 41.2313 12.7243V1.06845H42.8269V12.7243C42.8269 13.1517 42.7219 13.5467 42.5117 13.9093C42.3016 14.259 42.0127 14.5375 41.6449 14.7447C41.2904 14.9519 40.8964 15.0555 40.463 15.0555H31.0072Z"
        fill={color}
      />
      <path
        d="M47.3632 15.0555C46.9298 15.0555 46.5293 14.9519 46.1615 14.7447C45.807 14.5375 45.5246 14.259 45.3145 13.9093C45.1043 13.5467 44.9993 13.1517 44.9993 12.7243V3.39963C44.9993 2.97224 45.1043 2.58372 45.3145 2.23404C45.5246 1.87141 45.807 1.58649 46.1615 1.37928C46.5293 1.17206 46.9298 1.06845 47.3632 1.06845H56.819C57.2524 1.06845 57.6464 1.17206 58.001 1.37928C58.3687 1.58649 58.6577 1.87141 58.8678 2.23404C59.0779 2.58372 59.183 2.97224 59.183 3.39963V12.7243C59.183 13.1517 59.0779 13.5467 58.8678 13.9093C58.6577 14.259 58.3687 14.5375 58.001 14.7447C57.6464 14.9519 57.2524 15.0555 56.819 15.0555H47.3632ZM47.3632 13.4819H56.819C57.0292 13.4819 57.2065 13.4107 57.3509 13.2683C57.5085 13.1128 57.5873 12.9315 57.5873 12.7243V3.39963C57.5873 3.19241 57.5085 3.01757 57.3509 2.87511C57.2065 2.7197 57.0292 2.64199 56.819 2.64199H47.3632C47.1531 2.64199 46.9692 2.7197 46.8116 2.87511C46.6672 3.01757 46.5949 3.19241 46.5949 3.39963V12.7243C46.5949 12.9315 46.6672 13.1128 46.8116 13.2683C46.9692 13.4107 47.1531 13.4819 47.3632 13.4819Z"
        fill={color}
      />
      <path
        d="M63.677 15.0555C63.2436 15.0555 62.843 14.9519 62.4753 14.7447C62.1207 14.5375 61.8383 14.259 61.6282 13.9093C61.4181 13.5467 61.313 13.1517 61.313 12.7243V1.06845H62.9087V12.7243C62.9087 12.9315 62.9809 13.1128 63.1254 13.2683C63.283 13.4107 63.4668 13.4819 63.677 13.4819H73.1328C73.3429 13.4819 73.5202 13.4107 73.6646 13.2683C73.8222 13.1128 73.901 12.9315 73.901 12.7243V1.06845H75.4967V12.7243C75.4967 13.1517 75.3916 13.5467 75.1815 13.9093C74.9714 14.259 74.6825 14.5375 74.3147 14.7447C73.9601 14.9519 73.5661 15.0555 73.1328 15.0555H63.677Z"
        fill={color}
      />
      <path
        d="M77.6858 15.0555V1.04903H79.2815V13.4819H91.8695V15.0555H77.6858Z"
        fill={color}
      />
      <path
        d="M93.0574 15.0555V1.06845H106V2.64199H94.653V7.26549H103.774V8.85846H94.653V13.4819H106V15.0555H93.0574Z"
        fill={color}
      />
      <path
        d="M34.4152 39.3385L29.2539 25.3515H30.9481L35.1047 36.58L39.2416 25.3515H41.1722L45.3288 36.58L49.446 25.3515H51.1796L46.0183 39.3385H44.6196L40.2069 27.3913L35.7942 39.3385H34.4152Z"
        fill={color}
      />
      <path
        d="M52.3885 39.3385V27.6827C52.3885 27.2553 52.4935 26.8668 52.7037 26.5171C52.9138 26.1545 53.1961 25.8695 53.5507 25.6623C53.9185 25.4551 54.319 25.3515 54.7524 25.3515H64.2082C64.6416 25.3515 65.0356 25.4551 65.3902 25.6623C65.7579 25.8695 66.0469 26.1545 66.257 26.5171C66.4671 26.8668 66.5722 27.2553 66.5722 27.6827V39.3385H64.9765V34.2294H53.9841V39.3385H52.3885ZM53.9841 32.6558H64.9765V27.6827C64.9765 27.4755 64.8977 27.3006 64.7401 27.1582C64.5957 27.0027 64.4184 26.925 64.2082 26.925H54.7524C54.5423 26.925 54.3584 27.0027 54.2008 27.1582C54.0564 27.3006 53.9841 27.4755 53.9841 27.6827V32.6558Z"
        fill={color}
      />
      <path
        d="M74.6144 39.3385V34.074L68.0938 25.3515H69.9259L75.4221 32.1896L80.8592 25.3515H82.7306L76.21 34.074V39.3385H74.6144Z"
        fill={color}
      />
      <path
        d="M9.23419 25.6517H0L12.9279 0V14.6581H22.162L9.23419 40.3099V25.6517Z"
        fill={color}
      />
    </svg>
  );
}

function LogoIcon({ size = 25, color = "black" }: IconProps) {
  return (
    <svg
      width={size}
      viewBox="0 0 56 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3333 65.5455H0L32.6667 0V37.4545H56L23.3333 103V65.5455Z"
        fill={color}
      />
    </svg>
  );
}
